module.exports = __webpack_public_path__ + "img/monpatrol.fcd6480c.png";